<section class="sps-mehrfach-import">

  <!--
    DROP-OVERLAY: sobald Dateien über der Seite schweben, zeigt die ganze
    Seite, dass sie sie annimmt – egal wo losgelassen wird.
  -->
  <div class="drop-overlay" *ngIf="isDragging" aria-hidden="true">
    <div class="drop-overlay-inhalt">
      <mat-icon>file_download</mat-icon>
      <strong>Excel-Dateien hier loslassen</strong>
      <span>XLSX, XLSM oder XLS · mehrere Dateien auf einmal möglich</span>
    </div>
  </div>

  <!-- HEADER -->
  <header class="import-header">
    <div class="header-main">
      <button mat-icon-button type="button" (click)="zurueckZumProjekt()" matTooltip="Zurück zum Projekt">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div>
        <h1>Listen importieren</h1>
        <p *ngIf="projektName">{{ projektName }}</p>
      </div>
    </div>
  </header>


  <!-- SCHRITTANZEIGE -->
  <div class="wizard-schritte">

    <div class="wizard-schritt" [class.aktiv]="schritt === 1" [class.erledigt]="schritt > 1">
      <span class="wizard-nummer">1</span>
      <span>Dateien auswählen</span>
    </div>

    <mat-icon>chevron_right</mat-icon>

    <div class="wizard-schritt" [class.aktiv]="schritt === 2" [class.erledigt]="schritt > 2">
      <span class="wizard-nummer">2</span>
      <span>Vorschauen</span>
    </div>

    <mat-icon>chevron_right</mat-icon>

    <div class="wizard-schritt" [class.aktiv]="schritt === 3">
      <span class="wizard-nummer">3</span>
      <span>Import abschließen</span>
    </div>

  </div>


  <!-- ALLGEMEINER HINWEIS (Validierung, Importstand) -->
  <div class="fehlermeldung hinweis-oben" *ngIf="fehler">
    <mat-icon>error_outline</mat-icon>
    <span>{{ fehler }}</span>
  </div>


  <!-- =====================================================
       SCHRITT 1 – DATEIEN AUSWÄHLEN
       ===================================================== -->
  <ng-container *ngIf="schritt === 1">

    <mat-card class="import-card">
      <mat-card-content>

        <div class="section-title">
          <mat-icon>upload_file</mat-icon>
          <div>
            <h2>Excel-Dateien auswählen</h2>
            <p>
              Wähle eine oder mehrere Listen aus.
              Der Listentyp wird automatisch erkannt und kann korrigiert werden.
            </p>
          </div>
        </div>

        <!--
          Drag & Drop wird seitenweit in der Komponente behandelt (HostListener
          am Dokument), die Zone zeigt nur den Zustand an. So landet eine
          daneben losgelassene Datei nicht beim Browser.
        -->
        <div class="upload-zone" [class.drag-active]="isDragging">

          <mat-icon>{{ isDragging ? 'file_download' : 'cloud_upload' }}</mat-icon>

          <strong>{{ isDragging ? 'Dateien jetzt loslassen' : 'Dateien hinzufügen' }}</strong>

          <span>Excel-Dateien hierher ziehen oder auswählen · Unterstützte Formate: XLSX, XLSM, XLS</span>

          <input #dateiInput type="file" multiple accept=".xlsx,.xlsm,.xls" hidden (change)="dateienGewaehlt($event)">

          <button mat-raised-button color="primary" type="button" [disabled]="importLaeuft"
            (click)="dateiInput.click()">
            <mat-icon>add</mat-icon>
            {{ dateien.length ? 'Weitere Dateien auswählen' : 'Dateien auswählen' }}
          </button>
        </div>

        <div class="auswahl-info" *ngIf="dateien.length">
          <mat-icon>info_outline</mat-icon>
          {{ dateien.length }} Datei{{ dateien.length === 1 ? '' : 'en' }} ausgewählt.
          Es wurde noch nichts importiert.
        </div>

      </mat-card-content>
    </mat-card>


    <div class="import-layout" *ngIf="dateien.length > 0">

      <!-- LINKS: DATEILISTE -->
      <mat-card class="dateiliste-card">
        <mat-card-content>

          <div class="panel-header">
            <h2>Ausgewählte Dateien</h2>
            <span>{{ dateien.length }}</span>
          </div>

          <div class="dateiliste">

            <button type="button" class="datei-item" *ngFor="let d of dateien; let i = index; trackBy: trackByDatei"
              [class.aktiv]="aktuelleDateiIndex === i" (click)="dateiAnzeigen(i)">

              <mat-icon class="datei-icon">{{ typIcon(d.listenTyp) }}</mat-icon>

              <div class="datei-info">
                <strong>{{ d.file.name }}</strong>

                <span *ngIf="d.erkennungLaeuft">Wird erkannt …</span>
                <span *ngIf="!d.erkennungLaeuft">{{ typTitel(d.listenTyp) }}</span>

                <small>{{ dateigroesse(d.file.size) }}</small>
              </div>

              <mat-spinner *ngIf="d.erkennungLaeuft" diameter="20"></mat-spinner>

              <mat-icon *ngIf="!d.erkennungLaeuft && !d.fehler && d.listenTyp !== 'Unbekannt'" class="datei-ok">
                check_circle
              </mat-icon>

              <mat-icon *ngIf="!d.erkennungLaeuft && (d.fehler || d.listenTyp === 'Unbekannt')" class="datei-warnung">
                warning_amber
              </mat-icon>

            </button>

          </div>

        </mat-card-content>
      </mat-card>


      <!-- RECHTS: AKTUELLE DATEI -->
      <mat-card class="dateidetail-card" *ngIf="aktuelleDatei as d">
        <mat-card-content>

          <div class="panel-header">
            <div>
              <span class="schritt">Datei {{ aktuelleDateiIndex + 1 }} von {{ dateien.length }}</span>
              <h2>{{ d.file.name }}</h2>
              <p>{{ dateigroesse(d.file.size) }}</p>
            </div>

            <button mat-icon-button type="button" color="warn" [disabled]="importLaeuft" (click)="entfernen(d)"
              matTooltip="Datei entfernen">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>

          <div class="erkennung-bereich">

            <div class="ladezustand" *ngIf="d.erkennungLaeuft">
              <mat-spinner diameter="24"></mat-spinner>
              Datei wird analysiert …
            </div>

            <ng-container *ngIf="!d.erkennungLaeuft">

              <div class="erkennung-info" *ngIf="d.erkennung">
                <mat-icon>auto_awesome</mat-icon>

                <div>
                  <strong>Automatische Erkennung</strong>

                  <p>
                    {{ typTitel(d.erkennung.typ) }}
                    · Sicherheit {{ d.erkennung.sicherheit | percent:'1.0-0' }}
                    <ng-container *ngIf="d.erkennung.blatt"> · Blatt „{{ d.erkennung.blatt }}“</ng-container>
                  </p>

                  <small *ngIf="!d.erkennung.eindeutig">
                    Der Dateityp konnte nicht eindeutig erkannt werden. Bitte überprüfe die Auswahl.
                  </small>

                  <small *ngIf="d.typManuellGesetzt && d.erkennung.typ !== d.listenTyp">
                    Manuell geändert auf {{ typTitel(d.listenTyp) }}.
                  </small>
                </div>
              </div>

              <!-- MANUELLE TYPÄNDERUNG -->
              <div class="typ-auswahl">
                <label [attr.for]="'listenTyp-' + d.id">Listentyp</label>

                <select [id]="'listenTyp-' + d.id" [value]="d.listenTyp" [disabled]="importLaeuft"
                  (change)="typAuswahlGeaendert(d, $event)">

                  <option value="Unbekannt">Bitte auswählen</option>

                  <option *ngFor="let typ of listenTypen" [value]="typ">{{ typTitel(typ) }}</option>

                </select>


              </div>

            </ng-container>

          </div>

          <div class="fehlermeldung" *ngIf="d.fehler">
            <mat-icon>error_outline</mat-icon>
            <span>{{ d.fehler }}</span>
            <button mat-button type="button" (click)="erkennungStarten(d)">Erneut versuchen</button>
          </div>

        </mat-card-content>
      </mat-card>

    </div>


    <!-- ÜBERSICHT UND WEITER -->
    <mat-card class="import-card" *ngIf="dateien.length > 0">
      <mat-card-content>

        <h2>Importübersicht</h2>

        <div class="listenarten-grid">

          <div class="listenart" *ngFor="let typ of listenTypen">
            <mat-icon>{{ typIcon(typ) }}</mat-icon>
            <div>
              <strong>{{ anzahl(typ) }}</strong>
              <span>{{ typTitel(typ) }}{{ anzahl(typ) === 1 ? '' : 'n' }}</span>
            </div>
          </div>

        </div>

        <p class="beschreibung">
          {{ dateien.length }} Datei{{ dateien.length === 1 ? '' : 'en' }} ausgewählt.
          <ng-container *ngIf="anzahl('Unbekannt') > 0">
            {{ anzahl('Unbekannt') }} ohne Listentyp.
          </ng-container>
        </p>

        <div class="abschluss-aktionen">

          <button mat-button type="button" (click)="zurueckZumProjekt()">Abbrechen</button>

          <button mat-raised-button color="primary" type="button" [disabled]="!bereitFuerVorschau"
            [matTooltip]="vorschauBlockiertGrund || ''" (click)="weiterZuVorschauen()">
            Weiter zu den Vorschauen
            <mat-icon>arrow_forward</mat-icon>
          </button>

        </div>

      </mat-card-content>
    </mat-card>

  </ng-container>


  <!-- =====================================================
       SCHRITT 2 – VORSCHAUEN (volle Breite)

       Die Karte bleibt im DOM und wird nur verborgen, damit die eingebetteten
       KI-Komponenten ihren Zustand behalten. Die SPS-Vorschau ist reine
       Anzeige der Serverdaten und darf jederzeit neu aufgebaut werden.
       ===================================================== -->
  <mat-card class="import-card vorschau-card" [hidden]="schritt !== 2">
    <mat-card-content>

      <ng-container *ngIf="aktuelleDatei as d">

        <div class="panel-header">
          <div class="vorschau-kopf">

            <div class="vorschau-position">
              <span>Vorschau {{ aktuelleDateiIndex + 1 }} von {{ dateien.length }}</span>
              <mat-progress-bar mode="determinate" [value]="((aktuelleDateiIndex + 1) / dateien.length) * 100">
              </mat-progress-bar>
            </div>

            <h2>{{ d.file.name }}</h2>

            <p>
              <span class="typ-chip">
                <mat-icon>{{ typIcon(d.listenTyp) }}</mat-icon>
                {{ typTitel(d.listenTyp) }}
              </span>
              · {{ dateigroesse(d.file.size) }}
              <span class="bestaetigt-chip" *ngIf="d.bestaetigt">
                <mat-icon>check</mat-icon> bestätigt
              </span>
            </p>
          </div>

          <button mat-stroked-button type="button" [disabled]="importLaeuft" (click)="zurDateiauswahl()"
            matTooltip="Listentyp ändern oder Dateien hinzufügen/entfernen">
            <mat-icon>tune</mat-icon>
            Dateien und Typen
          </button>
        </div>


        <!-- SPS-VORSCHAU -->
        <section class="vorschau-bereich" *ngIf="importZiel(d) === 'sps'">

          <div class="bereich-header">
            <h3>Importvorschau</h3>

            <div class="bereich-aktionen">
              <label class="blatt-auswahl" *ngIf="d.vorschau && d.vorschau.blaetter.length > 1">
                Tabellenblatt
                <select [value]="d.sheetName" [disabled]="d.vorschauLaeuft" (change)="vorschauBlattWechseln(d, $event)">
                  <option *ngFor="let blatt of d.vorschau.blaetter" [value]="blatt">{{ blatt }}</option>
                </select>
              </label>

              <button mat-stroked-button type="button" [disabled]="d.vorschauLaeuft" (click)="vorschauLaden(d)">
                <mat-icon>refresh</mat-icon>
                Aktualisieren
              </button>
            </div>
          </div>

          <div class="ladezustand" *ngIf="d.vorschauLaeuft">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <span>Vorschau wird geladen … Die Datei wird dafür erneut an den Server übertragen.</span>
          </div>

          <div class="fehlermeldung" *ngIf="d.fehler && !d.vorschauLaeuft">
            <mat-icon>error_outline</mat-icon>
            <span>{{ d.fehler }}</span>
            <button mat-button type="button" (click)="vorschauLaden(d)">Erneut versuchen</button>
          </div>

          <ng-container *ngIf="d.vorschau as v">

            <div class="vorschau-meta">
              <span><mat-icon>table_chart</mat-icon> Tabellenblatt: {{ v.blatt }}</span>
              <span>{{ v.zeilenGesamt }} Datenzeilen in der Datei</span>
              <span *ngIf="v.anlagenteilSpalteVerfuegbar"
                matTooltip="Diese Spalte kann im Schritt „Import abschließen“ als Quelle der Anlagenteile gewählt werden">
                <mat-icon>account_tree</mat-icon>
                Anlagenteilspalte „{{ v.anlagenteilExcelSpalte || v.anlagenteilSpalteVerfuegbar }}“
                <ng-container *ngIf="v.anlagenteile"> · {{ v.anlagenteile.werte.length }} Werte</ng-container>
              </span>
              <span *ngIf="v.erkannterTyp !== 'Unbekannt' && v.erkannterTyp !== v.listenTyp" class="meta-warnung">
                <mat-icon>warning_amber</mat-icon> Erkannt als {{ typTitel(v.erkannterTyp) }}
              </span>
            </div>

            <div class="vorschau-zahlen">
              <div><strong>{{ v.gueltig }}</strong><span>Importierbar</span></div>
              <div><strong>{{ v.ungueltig }}</strong><span>Übersprungen</span></div>
              <div><strong>{{ v.eingaenge }}</strong><span>Eingänge</span></div>
              <div><strong>{{ v.ausgaenge }}</strong><span>Ausgänge</span></div>
              <div><strong>{{ v.richtungUnbekannt }}</strong><span>Richtung unbekannt</span></div>
            </div>

            <div class="fehlermeldung" *ngIf="!v.typPasst">
              <mat-icon>warning</mat-icon>
              <span>
                Die Datei passt nicht zum gewählten Listentyp ({{ typTitel(v.listenTyp) }}):
                Pflichtspalten fehlen. Bitte Listentyp oder Tabellenblatt ändern.
              </span>
            </div>

            <div class="warnungen" *ngIf="v.warnungen.length">
              <strong>Hinweise zur Datei</strong>
              <p *ngFor="let warnung of v.warnungen">{{ warnung }}</p>
            </div>


            <!-- VORSCHAUTABELLE -->
            <div class="tabellen-header">
              <div>
                <h4>Erkannte Einträge</h4>
                <p>Vorschau der Excel-Daten – die Datei wurde noch nicht importiert.</p>
              </div>

              <span class="vorschau-anzahl" *ngIf="v.vorschauZeilenGesamt > 0">
                Zeilen {{ v.ersteZeileAufSeite }}–{{ v.letzteZeileAufSeite }} von {{ v.vorschauZeilenGesamt }}
              </span>
            </div>

            <div class="tabellen-scroll" *ngIf="v.vorschau.length > 0" [class.tabelle-laedt]="d.vorschauLaeuft">

              <table class="excel-tabelle">
                <thead>
                  <tr>
                    <th class="spalte-zeile">Zeile</th>
                    <th>Signal</th>
                    <th *ngIf="d.listenTyp === 'SpsZuordnungsliste'">BMK</th>
                    <th *ngIf="d.listenTyp === 'PlcTagListe'">SPS-Adresse</th>
                    <th>Beschreibung</th>
                    <th>Richtung</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let zeile of aktuelleVorschauZeilen" [class.zeile-ungueltig]="!zeile.gueltig">

                    <td class="spalte-zeile">{{ zeile.excelZeile }}</td>

                    <td class="spalte-name">{{ zeile.signalname || '–' }}</td>

                    <td *ngIf="d.listenTyp === 'SpsZuordnungsliste'">{{ zeile.bmk || '–' }}</td>

                    <td class="spalte-adresse" *ngIf="d.listenTyp === 'PlcTagListe'">{{ zeile.adresseOriginal || '–' }}
                    </td>

                    <td class="spalte-beschreibung">{{ zeile.beschreibung || '–' }}</td>

                    <td>
                      <span class="richtung-chip" [class.richtung-eingang]="zeile.richtung === 'Eingang'"
                        [class.richtung-ausgang]="zeile.richtung === 'Ausgang'">
                        {{ zeile.richtung === 'Eingang' ? 'Eingang' : zeile.richtung === 'Ausgang' ? 'Ausgang' :
                        'Unbekannt' }}
                      </span>

                      <small class="zeilen-hinweis" *ngIf="!zeile.gueltig">
                        {{ zeile.hinweis || 'Wird nicht importiert' }}
                      </small>
                    </td>

                  </tr>
                </tbody>
              </table>

            </div>

            <!-- SEITENNAVIGATION -->
            <div class="vorschau-pagination" *ngIf="v.vorschauZeilenGesamt > 0">

              <div class="pagination-groesse">
                <label>Einträge pro Seite</label>

                <select [value]="d.vorschauSeitengroesse" [disabled]="d.vorschauLaeuft"
                  (change)="vorschauSeitengroesseAendern($event)">
                  <option *ngFor="let groesse of vorschauSeitengroessen" [value]="groesse">{{ groesse }}</option>
                </select>
              </div>

              <div class="pagination-rechts">
                <span>Seite {{ v.seite }} von {{ v.seitenGesamt }}</span>

                <button mat-icon-button type="button" [disabled]="v.seite <= 1 || d.vorschauLaeuft"
                  (click)="vorschauSeiteWechseln(-1)" matTooltip="Vorherige Seite">
                  <mat-icon>chevron_left</mat-icon>
                </button>

                <button mat-icon-button type="button" [disabled]="v.seite >= v.seitenGesamt || d.vorschauLaeuft"
                  (click)="vorschauSeiteWechseln(1)" matTooltip="Nächste Seite">
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>

            </div>

            <div class="leere-vorschau" *ngIf="v.vorschau.length === 0">
              <mat-icon>table_rows</mat-icon>
              Keine Einträge in der Vorschau vorhanden.
            </div>

            <!-- LISTENNAME -->
            <div class="listenname">
              <label [attr.for]="'listenname-' + d.id">Name der Liste</label>
              <input [id]="'listenname-' + d.id" type="text" [value]="d.name ?? ''" [disabled]="importLaeuft"
                (input)="d.name = ($any($event.target).value || null)"
                [placeholder]="d.file.name.replace('.xlsx', '').replace('.xlsm', '').replace('.xls', '')">
              <small>Leer lassen, um den Dateinamen zu verwenden.</small>
            </div>

            <p class="vorschau-hinweis">
              Alle {{ v.zeilenGesamt }} Datenzeilen sind seitenweise durchblätterbar. Beim bestätigten Import
              wird die gesamte Datei verarbeitet; es wurde noch nichts gespeichert.
            </p>

          </ng-container>

        </section>




      </ng-container>


      <!-- EINGEBETTETE KI-KOMPONENTEN – je KI-Datei eine Instanz, dauerhaft erhalten -->
      <ng-container *ngFor="let d of dateien; trackBy: trackByDatei">
        <div class="ki-container" [hidden]="d !== aktuelleDatei || importZiel(d) !== 'inbetriebnahme'">
          <app-messstellen-import *ngIf="d.kiAktiviert && importZiel(d) === 'inbetriebnahme'" [eingebettet]="true"
            [importDatei]="d.file" [importSchluessel]="d.id" [importListenTyp]="kiListenTyp(d)"
            [importProjektId]="projektId" [importProjektName]="projektName"
            (importVorbereitet)="kiVorbereitungUebernehmen(d, $event)"
            (vorbereitungUngueltig)="kiVorbereitungUngueltig(d)">
          </app-messstellen-import>
        </div>
      </ng-container>


      <!-- NAVIGATION -->
      <div class="navigation" *ngIf="aktuelleDatei">

        <button mat-stroked-button type="button" [disabled]="importLaeuft"
          (click)="aktuelleDateiIndex === 0 ? zurDateiauswahl() : vorherigeDatei()">
          <mat-icon>arrow_back</mat-icon>
          {{ aktuelleDateiIndex === 0 ? 'Zur Dateiauswahl' : 'Vorherige Vorschau' }}
        </button>

        <button mat-raised-button color="primary" type="button" [disabled]="importLaeuft"
          (click)="weiterZurBestaetigung()">
          {{ istLetzteDatei ? 'Weiter zur Zusammenfassung' : 'Nächste Vorschau' }}
          <mat-icon>arrow_forward</mat-icon>
        </button>

      </div>

    </mat-card-content>
  </mat-card>


  <!-- =====================================================
       SCHRITT 3 – ZUSAMMENFASSUNG UND IMPORT
       ===================================================== -->
  <mat-card class="import-card" *ngIf="schritt === 3">
    <mat-card-content>

      <h2>Import abschließen</h2>

      <p class="beschreibung">
        Prüfe die Zusammenfassung. Erst „Import starten“ speichert die Listen – jede Datei einzeln über den
        für ihren Typ vorgesehenen Import. Bereits gespeicherte Dateien werden nicht erneut gesendet.
      </p>

      <div class="listenarten-grid">
        <div class="listenart" *ngFor="let typ of listenTypen">
          <mat-icon>{{ typIcon(typ) }}</mat-icon>
          <div>
            <strong>{{ anzahl(typ) }}</strong>
            <span>{{ typTitel(typ) }}{{ anzahl(typ) === 1 ? '' : 'n' }}</span>
          </div>
        </div>
      </div>


      <!-- ANLAGENTEILE AUS ORT BZW. PATH -->
      <section class="anlagenteil-quelle" *ngIf="anlagenteilAuswahlSichtbar && !importGestartet">
        <h3>
          <mat-icon>account_tree</mat-icon>
          Anlagenteile übernehmen aus
        </h3>

        <p class="beschreibung">
          Die Zellwerte der gewählten Spalte werden exakt als Anlagenteile des Projekts angelegt
          (z. B. „+K9“ oder „09-Hydraulik“) – nicht zerlegt, nicht umbenannt. Vorhandene Anlagenteile
          des Projekts werden wiederverwendet, jeder Wert entsteht nur einmal.
        </p>

        <!-- Feste Optionen (kein Neuaufbau je Change Detection), 'keine' statt null als Wert. -->
        <mat-button-toggle-group [value]="anlagenteilAuswahl" (change)="anlagenteilQuelleSetzen($event.value)"
          [disabled]="importLaeuft" aria-label="Quelle der Anlagenteile">
          <mat-button-toggle *ngFor="let o of anlagenteilOptionen; trackBy: trackByAnlagenteilOption" [value]="o.wert"
            [disabled]="!anlagenteilQuelleVerfuegbar(o.wert)">
            {{ o.text }}
          </mat-button-toggle>
        </mat-button-toggle-group>

        <ul class="anlagenteil-hinweise">
          <li *ngFor="let o of anlagenteilOptionen; trackBy: trackByAnlagenteilOption">
            <ng-container *ngIf="anlagenteilQuelleHinweis(o.wert) as hinweis">
              <mat-icon inline>block</mat-icon> Nicht wählbar – {{ hinweis }}
            </ng-container>
          </li>
        </ul>

        <p class="anlagenteil-gewaehlt">
          <mat-icon inline>check</mat-icon>
          Gewählt: <strong>{{ anlagenteilQuelleText }}</strong>
        </p>

        <div class="anlagenteil-vorschau" *ngIf="anlagenteilVorschau as av">
          <p class="anlagenteil-zahlen">
            <strong>{{ av.werte.length }}</strong> Anlagenteile erkannt ·
            <strong>{{ av.neu }}</strong> neu anzulegen ·
            <strong>{{ av.vorhanden }}</strong> bereits im Projekt vorhanden ·
            {{ av.eintraege }} Zeilen erhalten eine Zuordnung
          </p>

          <div class="anlagenteil-chips">
            <span class="anlagenteil-chip" *ngFor="let w of av.werte; trackBy: trackByAnlagenteilWert"
              [class.anlagenteil-chip-vorhanden]="w.vorhanden"
              [matTooltip]="w.anzahl + ' Zeile(n)' + (w.vorhanden ? ' – Anlagenteil vorhanden, wird wiederverwendet' : ' – wird neu angelegt')">
              <mat-icon inline>{{ w.vorhanden ? 'check_circle' : 'add_circle_outline' }}</mat-icon>
              {{ w.wert }}
              <small>{{ w.anzahl }}</small>
            </span>
          </div>

          <p class="beschreibung" *ngIf="av.werte.length === 0">
            In der gewählten Spalte stehen keine Werte.
          </p>
        </div>
      </section>

      <!-- JE DATEI -->
      <div class="zusammenfassung-liste">

        <div class="zusammenfassung-zeile" *ngFor="let d of dateien; trackBy: trackByDatei"
          [class.zeile-erfolgreich]="d.importStatus === 'erfolgreich'"
          [class.zeile-fehlgeschlagen]="d.importStatus === 'fehlgeschlagen'"
          [class.zeile-unklar]="d.importStatus === 'unklar'" [class.zeile-aktiv]="importAktuelleDateiId === d.id">

          <mat-icon class="zeile-icon">{{ typIcon(d.listenTyp) }}</mat-icon>

          <div class="zeile-text">
            <strong>{{ listenNameVon(d) }}</strong>
            <span class="zeile-meta">
              {{ d.file.name }} · {{ typTitel(d.listenTyp) }}
              <ng-container *ngIf="zeilenZumImport(d) !== null">
                · {{ zeilenZumImport(d) }} Einträge
              </ng-container>
              <ng-container *ngIf="ausgeschlosseneZeilen(d)">
                · {{ ausgeschlosseneZeilen(d) }} ausgeschlossen
              </ng-container>
            </span>

            <span class="zeile-warnung" *ngFor="let w of warnungenVon(d)">
              <mat-icon inline>warning_amber</mat-icon> {{ w }}
            </span>

            <span class="zeile-meldung" *ngIf="d.importMeldung">{{ d.importMeldung }}</span>

            <div class="zeile-aktionen" *ngIf="d.importStatus === 'unklar' && !importLaeuft">
              <button mat-stroked-button type="button" (click)="zurueckZumProjekt()">
                <mat-icon>folder_open</mat-icon>
                Im Projekt nachsehen
              </button>
              <button mat-stroked-button type="button" (click)="unklarAlsGespeichertMarkieren(d)">
                Liste ist bereits da
              </button>
              <button mat-stroked-button color="warn" type="button" (click)="unklarFreigeben(d)">
                Nicht gespeichert – erneut senden
              </button>
            </div>

            <div class="zeile-aktionen" *ngIf="d.importStatus === 'erfolgreich' && d.importErgebnis">
              <button mat-button color="primary" type="button" (click)="ergebnisOeffnen(d)">
                <mat-icon>open_in_new</mat-icon>
                Liste öffnen
              </button>
            </div>
          </div>

          <div class="zeile-status">
            <mat-spinner *ngIf="d.importStatus === 'wirdImportiert'" diameter="20"></mat-spinner>

            <span class="status-chip" [ngClass]="'status-' + d.importStatus">
              {{ d.importStatus === 'bereit' && !d.bestaetigt ? 'Nicht bestätigt' : statusText(d.importStatus) }}
            </span>

            <button mat-icon-button type="button"
              *ngIf="d.importStatus === 'bereit' || d.importStatus === 'fehlgeschlagen'" [disabled]="importLaeuft"
              (click)="vorschauOeffnen(d)" matTooltip="Vorschau öffnen">
              <mat-icon>visibility</mat-icon>
            </button>
          </div>

        </div>

      </div>


      <!-- AKTIONEN -->
      <div class="abschluss-aktionen" *ngIf="!importAbgeschlossen">

        <button mat-stroked-button type="button" [disabled]="importLaeuft" (click)="zurLetztenVorschau()">
          <mat-icon>arrow_back</mat-icon>
          Zurück
        </button>

        <button mat-raised-button color="primary" type="button" [disabled]="!kannImportStarten"
          [matTooltip]="importBlockiertGrund || ''" (click)="gesamtimportStarten()">
          <mat-spinner *ngIf="importLaeuft" diameter="20"></mat-spinner>
          <mat-icon *ngIf="!importLaeuft">save</mat-icon>
          {{ importLaeuft
          ? 'Listen werden importiert …'
          : (importGestartet ? 'Offene Listen erneut importieren' : 'Import starten') }}
        </button>

      </div>

      <p class="transaktions-hinweis" *ngIf="!importGestartet">
        <mat-icon inline>info_outline</mat-icon>
        Jede Datei wird einzeln gespeichert. Schlägt eine fehl, bleiben die anderen erhalten; das Ergebnis steht je
        Datei hier.
      </p>


      <!-- ABSCHLUSS -->
      <div class="import-ergebnis" *ngIf="importAbgeschlossen">

        <div class="import-ergebnis-kopf">
          <mat-icon class="ergebnis-ok">check_circle</mat-icon>
          <div>
            <strong>Import abgeschlossen</strong>
            <p>{{ erfolgreicheDateien.length }} Liste{{ erfolgreicheDateien.length === 1 ? '' : 'n' }} gespeichert.</p>
          </div>
        </div>

        <div class="abschluss-aktionen">
          <button mat-stroked-button type="button" (click)="neuenImportBeginnen()">
            <mat-icon>add</mat-icon>
            Weitere Listen importieren
          </button>

          <button mat-stroked-button color="primary" type="button"
            *ngIf="anzahl('SpsZuordnungsliste') + anzahl('PlcTagListe') > 0" (click)="zurSpsPruefung()">
            <mat-icon>fact_check</mat-icon>
            SPS-Prüfung öffnen
          </button>

          <button mat-raised-button color="primary" type="button" (click)="zurueckZumProjekt()">
            Zur Projektansicht
            <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>

      </div>

    </mat-card-content>
  </mat-card>

</section>